/*
  Smooth in-page scroll helper that respects the user's motion preference.

  - Works for mouse and keyboard activation (callers wire it to onClick; native
    links/buttons fire onClick on Enter/Space).
  - When `prefers-reduced-motion: reduce` is set, jumps instantly instead of
    animating.
  - Moves focus to the target section so keyboard users land in the right place.
*/
export function scrollToId(id) {
  if (typeof document === "undefined") return;
  const el = document.getElementById(id);
  if (!el) return;

  const prefersReduced =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  el.scrollIntoView({
    behavior: prefersReduced ? "auto" : "smooth",
    block: "start",
  });

  // Move focus to the target for keyboard users without adding a visible outline
  // on the whole section (tabIndex -1 makes it programmatically focusable).
  if (el.getAttribute("tabindex") === null) {
    el.setAttribute("tabindex", "-1");
  }
  el.focus({ preventScroll: true });
}
